export default {"src":"/_next/static/image/public/images/flags/flag_223.dfc7f4b246cd93fd047cb59ce824227c.svg","height":16,"width":24};